import * as React from "react";
import Show from "../../../FormRegistration/components/Show";

export interface MatchGoalProps {
  player_name: string;
  club_name: string;
  home_away: "home" | "away";
  time_minute: number;
  owngoal_status: number;
  penalty_status: number;
  assist_name: string;
}

export interface NewMatchGoalProps {
  id: number;
  player_name: string;
  player_id: number;
  team_type: "home" | "away";
  school_id: number;
  minute: number;
  is_own_goal: number;
}

export interface ScoreItemProps {
  item: NewMatchGoalProps;
  textAlign: "left" | "right";
}

const ScoreItem: React.FC<ScoreItemProps> = ({ item, textAlign = "left" }) => {
  const goalScorerName = item?.player_name;

  const minutesTime = `${item?.minute}'`;

  const handleGoalDescription = React.useCallback(() => {
    return `${goalScorerName ?? "-"} ${minutesTime ?? "0"}`;
  }, [goalScorerName]);

  const goalDescription = handleGoalDescription();

  return (
    <div className="flex flex-col">
      <p
        style={{ textAlign: textAlign }}
        className={`text-[12px] leading-[16px] text-white capitalize`}
      >
        {goalDescription}
      </p>
    </div>
  );
};

export interface ScoreBoardProps {
  data: NewMatchGoalProps[];
}

const ScoreBoard: React.FC<ScoreBoardProps> = ({ data }) => {
  const homeGoal = [...data]?.filter((val) => val?.team_type === "home");
  const awayGoal = [...data]?.filter((val) => val?.team_type === "away");

  return (
    <div className="flex justify-between bg-[#354D69] p-[16px] rounded-[8px] max-w-[708px] mx-auto">
      <div className="flex flex-col items-start gap-y-[4px] w-[45%]">
        {homeGoal?.map((data, idx) => (
          <ScoreItem textAlign="left" item={data} key={idx} />
        ))}
      </div>
      <div className="flex justify-center gap-y-[4px] w-[10%]">
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_4080_40446)">
            <path
              d="M14.1062 4.92422L11.3031 5.11172C11.1406 5.12109 10.9813 5.07734 10.85 4.98047C10.7188 4.88359 10.625 4.74922 10.5875 4.58984L9.9 1.86484C9.45 1.76484 8.98125 1.71484 8.5 1.71484C8.01875 1.71484 7.55312 1.76797 7.1 1.86484L6.4125 4.58984C6.37187 4.74609 6.27813 4.88359 6.15 4.98047C6.02187 5.07734 5.85938 5.12109 5.69688 5.11172L2.89375 4.92422C2.42812 5.71797 2.12188 6.62109 2.03125 7.58359L4.40625 9.08047C4.54375 9.16797 4.64375 9.29922 4.69375 9.45234C4.74375 9.60547 4.7375 9.77109 4.67812 9.92109L3.6375 12.5273C4.25938 13.2273 5.03125 13.793 5.9 14.1742L8.05937 12.3742C8.18437 12.2711 8.34062 12.2148 8.5 12.2148C8.65938 12.2148 8.81875 12.2711 8.94063 12.3742L11.1 14.1742C11.9688 13.793 12.7406 13.2273 13.3625 12.5273L12.3188 9.92109C12.2594 9.77109 12.2531 9.60547 12.3031 9.45234C12.3531 9.29922 12.4563 9.16797 12.5906 9.08047L14.9688 7.58359C14.875 6.62109 14.5719 5.71797 14.1062 4.92422ZM8.5 14.7148H8.52812H8.47188H8.5ZM2.27188 10.0836C2.3 10.1773 2.33125 10.2742 2.3625 10.368L2.27188 10.0836ZM4.625 2.99609L4.74375 2.91172C4.70312 2.93984 4.66563 2.96797 4.625 2.99609ZM12.3781 2.99922C12.3375 2.96797 12.2937 2.93672 12.2531 2.90859L12.3781 2.99922ZM14.7281 10.0805L14.6344 10.368C14.6687 10.2742 14.7 10.1773 14.7281 10.0805ZM8.5 0.214844C10.6217 0.214844 12.6566 1.0577 14.1569 2.55799C15.6571 4.05828 16.5 6.09311 16.5 8.21484C16.5 10.3366 15.6571 12.3714 14.1569 13.8717C12.6566 15.372 10.6217 16.2148 8.5 16.2148C6.37827 16.2148 4.34344 15.372 2.84315 13.8717C1.34285 12.3714 0.5 10.3366 0.5 8.21484C0.5 6.09311 1.34285 4.05828 2.84315 2.55799C4.34344 1.0577 6.37827 0.214844 8.5 0.214844ZM8.94063 10.393C8.67813 10.5836 8.32187 10.5836 8.05937 10.393L6.5625 9.30859C6.3 9.11797 6.19063 8.78047 6.29063 8.47109L6.8625 6.71172C6.9625 6.40234 7.25 6.19297 7.575 6.19297H9.425C9.75 6.19297 10.0375 6.40234 10.1375 6.71172L10.7094 8.47109C10.8094 8.78047 10.7 9.11797 10.4375 9.30859L8.94063 10.3961V10.393Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_4080_40446">
              <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0.5 16.2148)" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="flex flex-col items-end gap-y-[4px] w-[45%]">
        {awayGoal?.map((data, idx) => (
          <ScoreItem textAlign="right" item={data} key={idx} />
        ))}
      </div>
    </div>
  );
};

export default ScoreBoard;
